import React from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LayoutDashboard, Briefcase, Users, UserCog, Clock, LogOut, CalendarDays, Trash2, Package, HardHat, FileText, ShoppingCart } from "lucide-react";
import { NotificheContratti } from "@/components/NotificheContratti";
import logo from "@/assets/logo-mcm.png";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/commesse", label: "Commesse", icon: Briefcase },
  { to: "/preventivi", label: "Preventivi", icon: FileText },
  { to: "/ore-rapide", label: "Ore di Lavoro", icon: Clock },
  { to: "/ore-mensili", label: "Ore Mensili", icon: CalendarDays },
  { to: "/magazzino", label: "Magazzino", icon: Package },
  { to: "/acquisti", label: "Acquisti", icon: ShoppingCart, admin: true },
  { to: "/prestazioni", label: "Prestazioni", icon: HardHat },
  { to: "/anagrafica", label: "Anagrafica", icon: Users },
  { to: "/utenti", label: "Utenti", icon: UserCog },
  { to: "/cestino", label: "Cestino", icon: Trash2 },
];

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const nav = NAV.filter((n) => !n.admin || isAdmin);

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <img src={logo} alt="MCM Saldature" className="h-9 rounded-md" data-testid="app-logo" />
          </div>

          <nav className="flex items-center gap-1">
            {nav.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-primary text-white"
                      : "text-slate-600 hover:bg-slate-100"
                  }`
                }
              >
                <n.icon className="h-4 w-4" />
                <span className="hidden sm:inline">{n.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <div className="text-right hidden md:block">
              <div className="text-sm font-medium text-slate-800 leading-none">
                {user?.name || "Utente"}
              </div>
              <div className="text-xs text-slate-400 mt-0.5">
                {isAdmin ? "Amministratore" : "Operatore"}
              </div>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={doLogout}
              data-testid="logout-button"
              className="text-slate-500 hover:text-red-600"
            >
              <LogOut className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-8 py-6 sm:py-8">
        <NotificheContratti />
        <Outlet />
      </main>
    </div>
  );
}
